import { render, staticRenderFns } from "./QuotesTable.vue?vue&type=template&id=5b0afa68&scoped=true&"
import script from "./QuotesTable.vue?vue&type=script&lang=ts&"
export * from "./QuotesTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesTable.vue?vue&type=style&index=0&id=5b0afa68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0afa68",
  null
  
)

export default component.exports